import { useQuery } from '@apollo/client';
import { useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import { GET_FUTURE_ROUTES_BY_DRIVER } from '../services/graphql/routes/routes-querys';
import { driverStateAtom } from '../services/recoil/atoms/driverState';
import { futureRoutesStateAtom } from '../services/recoil/atoms/futureRoutesState';
import { mutationStateAtom } from '../services/recoil/atoms/mutationState';

export function useFutureRoutesData(userId: string | undefined) {
  const setFutureRoutes = useSetRecoilState(futureRoutesStateAtom);
  const userInfo = useRecoilValue(driverStateAtom);

  const { data, refetch } = useQuery(GET_FUTURE_ROUTES_BY_DRIVER, {
    variables: { userId },
    skip: !userId || userInfo?.role !== 'Driver',
  });

  useEffect(() => {
    if (data && data.getFutureRoutesByDriver) {
      const routes = data.getFutureRoutesByDriver.data ?? [];
      setFutureRoutes(routes);
    }
  }, [data, userId, mutationStateAtom]);

  return { data, refetch };
}
